var SETTINGS_CAROUSEL = 'carousel.tag.name';
var CarouselTags = require('./carousel-tags');

angular.module('account.tags.index', [
  'security.authorization',
  'services.utility',
  'resources.Tag',
  'services.adminResource',
  'services.search',
  'filters.timeAgo',
  'services.formErrors',
  'services.algoliaResource',
  'services.localizedMessages',
])

.config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('account.tags', {
      url: '/tags?limit&oficial&skip&tag',
      title: 'Manage Tags',
      views: {
        'main@': {
          template: require('./tags.tpl.html'),
          controller: 'TagsIndexCtrl',
          resolve: {
            roles: ["adminResource", function(adminResource) {
              return adminResource.searchRoles({type: 'profile'});
            }]
          }
        }
      },
      resolve: {
        initSearch: ["searchService", "Tag", "$state", function (searchService, Tag,$state) {
          searchService.setSearchFn(Tag.search);
          searchService.setRedirectBase('/account/tags/edit');
        }]
      }
    });
}])

.controller('TagsIndexCtrl', ["$scope", "$route", "$location", "$log", "utility", "adminResource", "searchService", "$stateParams", "user", "roles", "Tag", "formErrors", "algoliaResource", "localizedMessages", function($scope, $route, $location, $log, utility, adminResource, searchService, $stateParams, user, roles, Tag, formErrors, algoliaResource, localizedMessages) {
  $scope.localizedMessages = localizedMessages;
  $scope.loadingIndicator = false;
  $scope.carouselTags = new CarouselTags(adminResource);

  // Old code
  // Settings.get( {name: _CAROUSEL}).$promise.then( function (data) {
  //   $scope.carouselTag = data.value || 'not set';
  // }, function(e) {
  //   console.error(e);
  // });

  $scope.isTagAdmin = user.permissions.is_admin || user.permissions.is_editor;
  $scope.search = searchService.search;
  $scope.isDraftsTab = false;
  $scope.draftTags = [];
  $scope.openDraftsTab = function() {
    $scope.query.searchDrafts = $scope.isDraftsTab = true;
    $scope.tags = [];
  }
  $scope.openTagsTab = function() {
    $scope.tags = [];
    $scope.query.searchDrafts = $scope.isDraftsTab = false;
  }
  //$scope.tags = tags.data;
  $scope.getTag = function ($item) {
    //hola javi 2
    // $location.path('/account/tags/edit/' + $item._id);

    // console.log("------->>>>>>>>"+$scope.query.tag.name);
      $scope.tag = $item.name + ' performance';
      $scope.query.tag = $scope.query.tag.name;
      $scope.query.oficial = 2;
  };
  // local var
  var deserializeData = function(data){
    $scope.page = data.meta.page;
    // $scope.query = data.meta.query;
    if($scope.isDraftsTab) {
      $scope.draftTags = _.map(data.data,function(e){
        e.draftProposers = _.map(e.drafts,function(draft){
        return draft.draftProposer;
        }).join(', ');
        return e;
      });
    } else {
      $scope.tags = data.data;
    }
  };

  $scope.removeTag = function(tag) {
    if (!confirm('Would you like to delete tag "' + tag.name + '" and all references in articles ? DANGER: tag cannot be restored after deletion !')) {
      return;
    }

    $scope.loadingIndicator = true;
    Tag.delete({
      id: tag._id
    }, function (result) {
      fetchData();
    }, function(e) {
      $scope.loadingIndicator = false;
      formErrors.growlErrors(e);
    });
  };


  var fetchData = function () {
    adminResource.searchTags($scope.query).then(function(data) {
        deserializeData(data);
        $scope.loadingIndicator = false;
    }, function(e) {
      $log.error(e);
      $scope.loadingIndicator = false;
    });
  };

  $scope.$watchCollection('query', _.debounce(function (newState, oldState) {
    if ( angular.equals(newState, oldState) ) {
      return;
    }
    $scope.loadingIndicator = true;
    fetchData();
  }, 700));

  $scope.limits = [
    {label: "10 Materiałów", value: 10},
    {label: "20 Materiałów", value: 20},
    {label: "50 Materiałów", value: 50},
    {label: "100 Materiałów", value: 100}
  ];
  roles = roles && roles.data ? roles.data.map( function(r) {
    return {
      _id: r._id,
      id: r.role_id,
      name: r.name,
    };
  }) : [];
  $scope.roles = [{
    _id: null,
    id: null,
    name: 'No role'
  }].concat(roles);

  $scope.query = $location.search();
  $scope.query.limit = $scope.query.limit || $scope.limits[0].value;
  $scope.query.tag = $scope.query.tag || '';
  $scope.query.oficial = $scope.query.oficial || 1;
  fetchData();

  $scope.algoliaReindexing = function() {
    algoliaResource.indexingTags().then((result) =>{
        $scope.algoliaSuccess = true;
    }).catch((error) => {
        $scope.algoliaError = true;
    })
  }
}]);




// WEBPACK FOOTER //
// ./client/src/app/account/tags/tags.js